<template>
  <div>
    <el-table
      border
      :data="tableData"
      :header-cell-style="{background:'#f2f2f2',color:'black'}"
      :height="tableHeightRow.height"
      class="table-height"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')"
        align="center"
        type="index"
        width="80"
        fixed="left"
      />
      <el-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :label="item.label"
        :min-width="item.width"
        :align="item.align"
        :prop="item.prop"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'status'">
            <el-tag v-if="scope.row.status === 0" type="danger">{{ $t('GlobalSetObj.disable') }}</el-tag>
            <el-tag v-if="scope.row.status === 1" type="primary">{{ $t('GlobalSetObj.enable') }}</el-tag>
          </div>
          <div v-else-if="item.prop === 'smallCalculateBase'">
            <span v-if="scope.row.smallCalculationMethod === 0">*</span>
            <span v-if="scope.row.smallCalculationMethod === 1">/</span>
            {{ scope.row[item.prop] }}
          </div>
          <div v-else-if="item.prop === 'largeCalculateBase'">
            <span v-if="scope.row.largeCalculationMethod === 0">*</span>
            <span v-if="scope.row.largeCalculationMethod === 1">/</span>
            {{ scope.row[item.prop] }}
          </div>
          <div v-else-if="item.prop === 'currentVersion'">
            <div style="cursor: pointer;color:#00a551" @click="viewHistory(scope.row)"><u>{{ scope.row[item.prop] }}</u></div>
          </div>
          <div v-else-if="item.prop === 'createUser' || item.prop === 'updateUser'">
            {{ getUserName(scope.row[item.prop], userNameStr) }}
          </div>
          <div v-else>
            {{ scope.row[item.prop] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('GlobalSetObj.operate')" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-permit:remove="'but:finance:basicData:channelVolume:view'"
            type="primary"
            size="mini"
            @click="viewDetail(scope.row, 1)"
          >
            {{ $t('GlobalSetObj.View') }}
          </el-button>
          <el-button
            v-permit:remove="'but:finance:basicData:channelVolume:iteration'"
            type="primary"
            size="mini"
            @click="viewDetail(scope.row, 2)"
          >
            {{ $t('ChannelManage.iteration') }}
          </el-button>
          <el-button
            v-if="scope.row.status === 0"
            v-permit:remove="'but:finance:basicData:channelVolume:edit'"
            type="primary"
            size="mini"
            @click="handleEdit(scope.row)"
          >
            {{ $t('GlobalSetObj.enable') }}
          </el-button>
          <el-button
            v-if="scope.row.status === 1"
            v-permit:remove="'but:finance:basicData:channelVolume:edit'"
            type="warning"
            size="mini"
            @click="handleEdit(scope.row)"
          >
            {{ $t('GlobalSetObj.disable') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { getUserName } from '@/utils/asyncTools';
import { channelVolumeConfigUpdateStatus } from '@/api/finance/basicData';
export default {
  name: 'TableCmp',
  mixins: [estimateTableHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columnList: [
        {
          label: this.$t('operationCenter.channel'), // 渠道
          width: '180',
          align: 'left',
          prop: 'channelName'
        },
        {
          label: this.$t('collectionCenter.stateZT'), // 状态
          width: '160',
          align: 'center',
          prop: 'status'
        },
        {
          label: this.$t('ChannelManage.version'), // 版本
          width: '160',
          align: 'center',
          prop: 'currentVersion'
        },
        {
          label: this.$t('ChannelManage.SmallParcelCoefficient'), // 快递小件系数
          width: '160',
          align: 'center',
          prop: 'smallCalculateBase'
        },
        {
          label: this.$t('ChannelManage.LargeParcelCoefficient'), // 快递大件系数
          width: '160',
          align: 'center',
          prop: 'largeCalculateBase'
        },
        {
          label: this.$t('GlobalSetObj.CreatePeople'), // 创建人
          width: '160',
          align: 'center',
          prop: 'createUser'
        },
        {
          label: this.$t('GlobalSetObj.CreationTime'), // 创建时间
          width: '180',
          align: 'center',
          prop: 'createTime'
        },
        {
          label: this.$t('collectionCenter.ModifiedBy'), // 修改人
          width: '160',
          align: 'center',
          prop: 'updateUser'
        },
        {
          label: this.$t('GlobalSetObj.ModificationTime'), // 修改时间
          width: '180',
          align: 'center',
          prop: 'updateTime'
        }
      ],
      userNameStr: null
    };
  },
  created() {
    this.userNameStr = getUserIdAndNameObj();
  },
  methods: {
    getUserName,
    // 查看历史版本
    viewHistory(row) {
      this.$emit('checkHistory', row);
    },
    // 查看详情
    viewDetail(row, type) {
      console.log(row);
      this.$emit('tableOperate', row, type);
    },
    // 启用禁用
    handleEdit(row) {
      const param = {
        id: row.id,
        status: row.status === 0 ? 1 : 0
      };
      const title = row.status === 0 ? this.$t('basicData.AreYouSureEnabled') : this.$t('basicData.AreYouSureDisabled');
      this.$confirm(title, this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'), // '确定'
        cancelButtonText: this.$t('collectionCenter.cancel'), // '取消'
        type: 'warning'
      }).then(async() => {
        channelVolumeConfigUpdateStatus(param).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.$emit('tableUpdate', true);
          }
        });
      });
    }
  }
};
</script>

<style scoped>

</style>
